import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {IconsModule} from '@aztrix/icons';
import {Agreement} from '@aztrix/models';
import {AgreementRepresentation} from '@aztrix/sdk';
import {TranslatePipe} from '@aztrix/translate';

import {AgreementStatusChipComponent} from '../agreement-status-chip/agreement-status-chip.component';

@Component({
  selector: 'ax-agreement-status',
  templateUrl: './agreement-status.component.html',
  styleUrls: ['../property.scss', './agreement-status.component.scss'],
  standalone: true,
  imports: [CommonModule, IconsModule, TranslatePipe, AgreementStatusChipComponent],
})
export class AgreementStatusComponent {
  @Input() proposalHasVerification = false;
  @Input() agreement?: Agreement | AgreementRepresentation;
  @Input() hasAgreementDataToDisplay? = false;

  get isActive() {
    return this.agreement?.active || false;
  }

  get isConfirmed() {
    return this.agreement?.agreementData?.confirmed || false;
  }

  get isVerified() {
    return this.agreement?.verified || false;
  }

  get activeStatus() {
    if (this.agreement?.deletedByOwner) {
      return 'deleted';
    }
    if (this.isActive) {
      return 'active';
    } else {
      return 'expired';
    }
  }
}
